import React from 'react';
import { string, arrayOf, shape, bool, number } from 'prop-types';
import classnames from 'classnames';
import CategoryListItem from '../CategoryListItem';
import './CategoryList.scss';

export const CategoryList = ({ values }) => {
    const rootClassnames = classnames(
        'category-list-root',
        'filter__options filter__options-categories',
    );
    return (
        <ul className={rootClassnames}>
            {values.map(({ active, id, imageUrl, label, url }) => (
                <CategoryListItem
                    imageUrl={imageUrl}
                    label={label}
                    url={url}
                    key={id}
                    active={active}
                />
            ))}
        </ul>
    );
};

CategoryList.propTypes = {
    values: arrayOf(
        shape({
            active: bool,
            id: number.isRequired,
            imageUrl: string.isRequired,
            label: string.isRequired,
            url: string.isRequired,
        }),
    ).isRequired,
};

CategoryList.displayName = 'CategoryList';

export default CategoryList;
